import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { Donut } from '../../../Common/Charts/Donut';
import { useHouseholdIncomeChartsDataContext } from './hooks/useHouseholdIncomeChartsDataContext';

export const FamilyBudget = () => {
    const { chartData } = useHouseholdIncomeChartsDataContext();

    return (
        <Donut
            title={'Orçamento Familiar'}
            subtitles={chartData?.familyBudget?.map(
                (item) => item.description
            )}
            chartData={chartData?.familyBudget || []}
            colors={
                defaultColors.slice(0, chartData?.familyBudget?.length) ||
                []
            }
            height={350}
        />
    );
};
